export const storyCategories = [
  "Adventure",
  "Animals",
  "Art",
  "Dinosaurs",
  "Emotions",
  "Fairytales",
  "Friendship",
  "Holidays",
  "Imagination",
  "Jobs",
  "Magic",
  "Music & performance",
  "Mysteries",
  "Nature",
  "Space",
  "Sports",
  "Superheroes",
  "Tools",
  "Toys",
  "Travel",
  "Vehicles",
];

export const storySubcategories = {
  Adventure: [
    "Safari",
    "Scavenger hunt",
    "Treasure hunt",
    "Explorations",
    "Rescue",
    "Challenges",
    "Discovery",
    "Quests",
    "Survival",
    "Time travel",
  ],
  Animals: [
    "Endangered",
    "Birds",
    "Farm",
    "Pets",
    "Mammals",
    "Zoo",
    "Insects",
    "Sea life",
    "Reptiles",
    "Reptile",
    "Wild",
  ],
  Art: [
    "Friendship bracelets",
    "Chalk drawing",
    "Drawing",
    "Crafting",
    "Painting",
    "Clay",
    "Paper airplanes",
    "Collage",
    "Crayons",
    "Origami",
    "Sculpture",
    "Stamps",
    "Temp tattoos",
    "Water colors",
  ],
  Dinosaurs: [
    "Extinction",
    "Excavation",
    "Carnivores",
    "Fossils",
    "Herbivores",
    "Velociraptor",
    "Stegosaurus",
    "Triceratops",
    "T-rex",
    "Pterodactyls",
    "Brachiosaurus",
  ],
  Emotions: [
    "Calmness",
    "Courage",
    "Excitement",
    "Happy",
    "Fear",
    "Confidence",
    "Deep breathing",
    "Empathy",
    "Focus",
    "Frustration",
    "Gratitude",
    "Jealousy",
    "Love",
    "Mood journals",
    "Surprise",
  ],
  Fairytales: [
    "Castles",
    "Curses",
    "Dwarves",
    "Fables",
    "Happy ever after",
    "Knights",
    "Heroic deeds",
    "Legends",
    "Princes",
    "Quests",
    "Tricksters",
    "Villains",
    "Dragons",
    "Princesses",
    "Witches",
  ],
  Friendship: [
    "Best friends",
    "Empathy",
    "Forgiveness",
    "High-fives",
    "Hugs",
    "Kindness",
    "New friends",
    "Inclusion",
    "Loyalty",
    "Trust",
    "Sharing",
    "Teamwork",
  ],
  Holidays: [
    "4th of july",
    "Anniversaries",
    "Birthdays",
    "Chinese new year",
    "Christmas",
    "Diwali",
    "Easter",
    "Halloween",
    "Hanukkah",
    "Juneteenth",
    "New year's",
    "Thanksgiving",
    "Valentine's",
  ],
  Imagination: [
    "Art projects",
    "Daydreaming",
    "Dress up",
    "Fun house",
    "Meditation",
    "Portal to alt universe",
    "Pretend play",
    "Puppet shows",
    "Story time",
  ],
  Jobs: [
    "Astronaut",
    "Doctor",
    "Veterinarian",
    "Musician",
    "Scientist",
    "Actor",
    "Architect",
    "Artist",
    "Athletic trainer",
    "Chef",
    "Dog walker",
    "Farmer",
    "Hotel concierge",
    "Judge",
    "Martial arts instructor",
    "Nurse",
    "Professor",
    "Pilots",
    "Race car driver",
    "Reporter",
    "Teacher",
    "Athletes",
    "Builders",
    "Firefighters",
    "Police",
  ],
  Magic: [
    "Enchanted",
    "Ghosts",
    "Magic wand",
    "Potions",
    "Fairies",
    "Spells",
    "Unicorns",
    "Wizards",
    "Time travel",
    "Warlocks",
    "Haunted house",
  ],
  "Music & performance": [
    "Drums",
    "Piano",
    "Silly songs",
    "Flute",
    "Guitar",
    "Harmonica",
    "Karaoke",
    "Lullabies",
    "Music videos",
    "Recorder",
    "Sing along",
    "Trumpet",
    "Violin",
    "Dance party",
  ],
  Mysteries: [
    "Disguises",
    "Detective stories",
    "Ghost stories",
    "Riddles",
    "Secret codes",
    "Treasure hunts",
    "Hidden clues",
    "Magic tricks",
    "Mysteries",
    "Puzzles",
    "Spy games",
    "Under cover",
    "Whodunnit",
  ],
  Nature: [
    "Deserts",
    "Flowers",
    "Seasons",
    "Forests",
    "Gardens",
    "Insects",
    "Mountains",
    "Oceans",
    "Plants",
    "Rainbows",
    "Rivers",
    "Trees",
    "Volcanos",
    "Weather",
    "storms",
  ],
  Space: [
    "Black holes",
    "Asteroids",
    "Aliens",
    "Astronauts",
    "Black hole",
    "Spaceships",
    "Moon",
    "Comets",
    "Light speed",
    "Planets",
    "Rockets",
    "Space travel",
    "Stars",
    "Supernova",
  ],
  Sports: [
    "Bowling",
    "Dancing",
    "Football",
    "Horse riding",
    "Ice skating",
    "Karate",
    "Rugby",
    "Running",
    "Skateboarding",
    "Skiing",
    "Snowboarding",
    "Team sports",
    "Tennis",
    "Basketball",
    "Baseball",
    "Biking",
    "Sledding",
    "Gymnastics",
    "Soccer",
    "Swimming",
  ],
  Superheroes: [
    "Disguises",
    "Gadgets",
    "Origin story",
    "Costumes",
    "Training",
    "Villains",
    "Rescue",
    "Sidekicks",
    "Save the world",
    "Super pets",
    "Superpowers",
    "Team ups",
  ],
  Tools: [
    "Saw",
    "Robots",
    "Diggers",
    "Levers",
    "Screwdriver",
    "Workshop",
    "Wrench",
    "Toolbox",
    "Tape measure",
    "Gears",
    "Level",
    "Magnets",
    "Pliers",
    "Pulleys",
    "Sandpaper",
  ],
  Toys: [
    "Action figs",
    "Arts&crafts",
    "Beach toys",
    "Board games",
    "Playsets",
    "Pool toys",
    "Puzzles",
    "Stuffed animals",
    "Blocks",
    "Cars",
    "Dolls",
    "Robots",
  ],
  Travel: [
    "Fishing trip",
    "Hike",
    "Hotel",
    "International",
    "Landmarks",
    "Road trip",
    "Ski resort",
    "Train ride",
    "Airplane flight",
    "City walk",
    "Camping",
    "Boat cruise",
    "Beach trips",
    "Maps",
  ],
  Vehicles: [
    "Racecars",
    "Rescue",
    "Submarines",
    "Space",
    "Trains",
    "Bicycles",
    "Helicopters",
    "Motorcycles",
    "Boats",
    "Cars",
    "Emergency",
    "Construction",
    "Planes",
    "Trucks",
  ],
};
